import { trpc } from '@/shared/api/trpc';

export const useUpdateTask = () => {
  const utils = trpc.useUtils();
  return trpc.tasks.update.useMutation({
    onSettled: (row) => {
      utils.tasks.list.invalidate();
      utils.tasks.flaggedCount.invalidate();
      utils.tasks.getNextActions.invalidate();
      if (row?.id) {
        utils.tasks.byId.invalidate({ id: row.id });
      }
    },
  });
};
